import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBulletlist = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M3.298 5.627a.564.564 0 1 0 0-1.127.564.564 0 0 0 0 1.127" />
    <path
      fillRule="evenodd"
      d="M3.298 5a.064.064 0 1 0 0 .127.064.064 0 0 0 0-.127m-1.063.064a1.064 1.064 0 1 1 2.127 0 1.064 1.064 0 0 1-2.127 0m4.259 0a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5H7.244a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path d="M3.298 10.7a.564.564 0 1 0 0-1.127.564.564 0 0 0 0 1.128Z" />
    <path
      fillRule="evenodd"
      d="M3.298 10.073a.064.064 0 1 0 0 .128.064.064 0 0 0 0-.128m-1.063.064a1.064 1.064 0 1 1 2.127 0 1.064 1.064 0 0 1-2.127 0m4.259 0a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5H7.244a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path d="M3.298 15.774a.564.564 0 1 0 0-1.127.564.564 0 0 0 0 1.127" />
    <path
      fillRule="evenodd"
      d="M3.298 15.146a.064.064 0 1 0 0 .128.064.064 0 0 0 0-.127Zm-1.063.064a1.064 1.064 0 1 1 2.127 0 1.064 1.064 0 0 1-2.127 0m4.259 0a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5H7.244a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBulletlist;
